import type { EventCategoryResource, EventResource, Repository, ResourceCollection } from "@octopusdeploy/octopus-server-client";
import EventListing from "~/components/EventListing/EventListing";
import { isFeatureToggleEnabled } from "~/components/FeatureToggle/New/FeatureToggleContext";
import { PageContent } from "~/components/PageContent/PageContent";
interface WorkerEventsPageProps {
    workerId: string;
    loaderData: WorkerEventsPageLoaderData;
}
interface WorkerEventsPageLoaderData {
    events: ResourceCollection<EventResource>;
    eventCategories: EventCategoryResource[];
}
export async function workerEventsPageLoader(repository: Repository, workerId: string): Promise<WorkerEventsPageLoaderData> {
    const optimizationEnabled = isFeatureToggleEnabled("PermissionCheckOptimizationFeatureToggle");
    const events = optimizationEnabled ? await repository.Events.getUnpaginatedEvents({ regarding: [workerId] }) : await repository.Events.list({ regarding: [workerId] });
    const eventCategories = await repository.Events.categories({});
    return { events, eventCategories };
}
const Title = "Events";
export function WorkerEventsPage({ workerId, loaderData }: WorkerEventsPageProps) {
    return (<PageContent header={{ title: Title }}>
            <EventListing data={loaderData.events} eventCategories={loaderData.eventCategories} regarding={[workerId]}/>
        </PageContent>);
}
